(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kf-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialiseCarousel = (section) => {
      if (section.dataset.kfCarouselInitialised === 'true') return;

      if (section.dataset.kfDesignMode === 'true') {
        section.querySelectorAll('.kf-carousel__view-all-visual a[href]').forEach((link) => {
          link.removeAttribute('href');
          link.removeAttribute('target');
        });
      }

      const track = section.querySelector('[data-kf-carousel-track]');
      const controls = section.querySelector('[data-kf-carousel-controls]');
      const previousButton = section.querySelector('[data-kf-carousel-previous]');
      const nextButton = section.querySelector('[data-kf-carousel-next]');

      if (!track || !controls || !previousButton || !nextButton) return;

      section.dataset.kfCarouselInitialised = 'true';

      const getGap = () => {
        const trackStyles = window.getComputedStyle(track);
        return parseFloat(trackStyles.columnGap || trackStyles.gap) || 0;
      };

      const getScrollAmount = () => {
        const firstItem = track.querySelector('.kf-carousel__item');

        return firstItem
          ? firstItem.getBoundingClientRect().width + getGap()
          : track.clientWidth;
      };

      const updateControls = () => {
        const maximumScroll = Math.max(
          0,
          track.scrollWidth - track.clientWidth
        );

        const hasOverflow = maximumScroll > 2;

        controls.hidden = !hasOverflow;
        previousButton.disabled = track.scrollLeft <= 2;
        nextButton.disabled =
          track.scrollLeft >= maximumScroll - 2;
      };

      previousButton.addEventListener('click', () => {
        track.scrollBy({
          left: -getScrollAmount(),
          behavior: 'smooth'
        });
      });

      nextButton.addEventListener('click', () => {
        track.scrollBy({
          left: getScrollAmount(),
          behavior: 'smooth'
        });
      });

      track.addEventListener('scroll', updateControls, {
        passive: true
      });

      if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(updateControls);
        resizeObserver.observe(track);
      } else {
        window.addEventListener('resize', updateControls);
      }

      updateControls();
    };

    const initialiseAllCarousels = (root = document) => {
      if (root.matches?.('[data-kf-carousel]')) {
        initialiseCarousel(root);
      }

      root
        .querySelectorAll('[data-kf-carousel]')
        .forEach(initialiseCarousel);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initialiseAllCarousels();
      });
    } else {
      initialiseAllCarousels();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initialiseAllCarousels(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kf-collection-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kf-collection-gallery')) {
    class KfCollectionGallery extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.viewport = this.querySelector('[data-gallery-viewport]');
        this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
        this.previousButton = this.querySelector('[data-gallery-previous]');
        this.nextButton = this.querySelector('[data-gallery-next]');
        this.currentLabel = this.querySelector('[data-gallery-current]');
        this.dots = Array.from(this.querySelectorAll('[data-gallery-dot]'));

        if (!this.viewport || this.slides.length < 2) return;

        this.dataset.initialized = 'true';
        this.currentIndex = 0;
        this.scrollFrame = null;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.handleScroll = this.handleScroll.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleResize = this.handleResize.bind(this);

        this.viewport.addEventListener('scroll', this.handleScroll, { passive: true });
        this.viewport.addEventListener('keydown', this.handleKeydown);

        this.previousButton?.addEventListener('click', () => this.goTo(this.currentIndex - 1));
        this.nextButton?.addEventListener('click', () => this.goTo(this.currentIndex + 1));

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.goTo(Number(dot.dataset.galleryDot)));
        });

        this.resizeObserver = new ResizeObserver(this.handleResize);
        this.resizeObserver.observe(this.viewport);
        this.updateNavigation();
      }

      disconnectedCallback() {
        this.viewport?.removeEventListener('scroll', this.handleScroll);
        this.viewport?.removeEventListener('keydown', this.handleKeydown);
        this.resizeObserver?.disconnect();

        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
      }

      getVisibleSlideCount() {
        const firstSlide = this.slides[0];
        if (!firstSlide) return 1;

        const track = this.querySelector('.kf-collection-gallery__track');
        const gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
        const slideWidth = firstSlide.getBoundingClientRect().width;

        return Math.max(1, Math.round(this.viewport.clientWidth / (slideWidth + gap)));
      }

      getMaximumStartIndex() {
        return Math.max(0, this.slides.length - this.getVisibleSlideCount());
      }

      getSlideLeft(slide) {
        return slide.offsetLeft - this.slides[0].offsetLeft;
      }

      getClosestIndex() {
        const maximumIndex = this.getMaximumStartIndex();
        let closestIndex = 0;
        let closestDistance = Infinity;

        this.slides.forEach((slide, index) => {
          if (index > maximumIndex) return;

          const distance = Math.abs(this.getSlideLeft(slide) - this.viewport.scrollLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        return closestIndex;
      }

      goTo(requestedIndex) {
        const targetIndex = Math.min(Math.max(requestedIndex, 0), this.getMaximumStartIndex());
        const targetSlide = this.slides[targetIndex];
        if (!targetSlide) return;

        this.viewport.scrollTo({
          left: this.getSlideLeft(targetSlide),
          behavior: this.reduceMotion.matches ? 'auto' : 'smooth',
        });
      }

      handleScroll() {
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);

        this.scrollFrame = requestAnimationFrame(() => {
          this.currentIndex = this.getClosestIndex();
          this.updateNavigation();
        });
      }

      handleKeydown(event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.goTo(this.currentIndex - 1);
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.goTo(this.currentIndex + 1);
        }
      }

      handleResize() {
        this.currentIndex = Math.min(this.currentIndex, this.getMaximumStartIndex());
        this.viewport.scrollTo({ left: this.getSlideLeft(this.slides[this.currentIndex]), behavior: 'auto' });
        this.updateNavigation();
      }

      updateNavigation() {
        const maximumIndex = this.getMaximumStartIndex();

        if (this.currentLabel) this.currentLabel.textContent = String(this.currentIndex + 1);
        if (this.previousButton) this.previousButton.disabled = this.currentIndex <= 0;
        if (this.nextButton) this.nextButton.disabled = this.currentIndex >= maximumIndex;

        this.dots.forEach((dot, index) => {
          const isCurrent = index === this.currentIndex;
          dot.classList.toggle('kf-collection-gallery__dot--current', isCurrent);

          if (isCurrent) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }
    }

    customElements.define('kf-collection-gallery', KfCollectionGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kf-colour-refine"] && !Shopify.designMode) return;
  try {
    

class KFColourRefine extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;

    this.dataset.initialized = 'true';

    this.range = this.querySelector('.kf-colour-refine__range');
    this.status = this.querySelector('[data-kf-colour-status]');

    if (!this.range || !this.status) return;

    this.loaded = false;
    this.activated = false;
    this.loadPromise = null;

    this.metadata = [];
    this.cards = new Map();

    this.range.addEventListener(
      'input',
      this.handleInput.bind(this)
    );

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => this.setupCollectionGrid(),
        { once: true }
      );
    } else {
      this.setupCollectionGrid();
    }
  }

  setupCollectionGrid() {
    this.resultsList =
      document.querySelector(
        'collection-component results-list[section-id]'
      );

    if (!this.resultsList) return;

    this.mainSectionId =
      this.resultsList.getAttribute('section-id');

    this.grid =
      this.resultsList.querySelector(
        '[data-testid="product-grid"]'
      );

    const wrapper =
      this.mainSectionId
        ? document.getElementById(
            `shopify-section-${this.mainSectionId}`
          )
        : null;

    if (!wrapper) return;

    this.gridObserver = new MutationObserver(() => {
      const currentGrid =
        document.querySelector(
          'collection-component results-list[section-id] [data-testid="product-grid"]'
        );

      /*
        If Shopify replaces the collection grid after
        filtering/sorting, reset the colour control.
      */
      if (
        currentGrid &&
        this.grid &&
        currentGrid !== this.grid
      ) {
        this.resetForNewGrid(currentGrid);
      }
    });

    this.gridObserver.observe(wrapper, {
      childList: true,
      subtree: true
    });
  }

  resetForNewGrid(newGrid) {
    this.grid = newGrid;

    this.resultsList =
      document.querySelector(
        'collection-component results-list[section-id]'
      );

    this.mainSectionId =
      this.resultsList?.getAttribute('section-id');

    this.loaded = false;
    this.activated = false;
    this.loadPromise = null;

    this.metadata = [];
    this.cards = new Map();

    this.range.value = '0';

    this.setStatus('Best selling');
    this.removeAttribute('aria-busy');
  }

  handleInput() {
    const value = Number(this.range.value);

    if (this.hasAttribute('aria-busy')) {
      this.setStatus('Preparing shade order…');
    } else {
      this.updateStatus(value);
    }

    /*
      Do absolutely nothing extra on the normal centre position.
      This keeps the initial collection behaviour unchanged.
    */
    if (value === 0 && !this.activated) {
      return;
    }

    /*
      First movement away from centre starts the background
      fetch. Further movements reuse the same promise.
    */
    if (!this.loaded) {
      this.ensureLoaded()
        .then(() => {
          const currentValue = Number(this.range.value);

          if (currentValue !== 0 || this.activated) {
            this.applyRanking(currentValue);
          } else {
            this.setStatus('Best selling');
          }
        })
        .catch((error) => {
          console.error(
            '[KF Colour Shade]',
            error
          );

          this.range.value = '0';

          this.setStatus(
            'Best selling'
          );

          this.removeAttribute('aria-busy');
        });

      return;
    }

    this.scheduleRanking(value);
  }

  updateStatus(value) {
    if (value === 0) {
      this.setStatus('Best selling');
      return;
    }

    if (value < 0) {
      this.setStatus('Lighter first');
      return;
    }

    this.setStatus('Darker first');
  }

  setStatus(text) {
    if (this.status) {
      this.status.textContent = text;
    }
  }

  ensureLoaded() {
    if (this.loaded) {
      return Promise.resolve();
    }

    if (this.loadPromise) {
      return this.loadPromise;
    }

    this.setAttribute('aria-busy', 'true');
    this.setStatus('Preparing shade order…');

    this.loadPromise = Promise.all([
      this.loadRankingData(),
      this.loadProductCards()
    ])
      .then(([metadata, cards]) => {
        this.metadata = metadata;
        this.cards = cards;

        this.loaded = true;

        this.removeAttribute('aria-busy');

        this.updateStatus(
          Number(this.range.value)
        );
      })
      .finally(() => {
        this.loadPromise = null;
      });

    return this.loadPromise;
  }

  async loadRankingData() {
    /*
      Fetch page 1 first so we get the current filtered
      collection's page count.
    */
    const firstHTML =
      await this.fetchSection(
        this.dataset.sectionId,
        1
      );

    const first =
      this.parseRankingSection(firstHTML);

    const items = [...first.items];

    if (first.pages > 1) {
      const pages = [];

      for (
        let page = 2;
        page <= first.pages;
        page++
      ) {
        pages.push(page);
      }

      const remaining =
        await this.fetchInBatches(
          pages,
          3,
          async (page) => {
            const html =
              await this.fetchSection(
                this.dataset.sectionId,
                page
              );

            return this.parseRankingSection(
              html
            ).items;
          }
        );

      remaining.forEach((pageItems) => {
        items.push(...pageItems);
      });
    }

    const unique = new Map();

    items.forEach((item) => {
      if (!unique.has(String(item.id))) {
        unique.set(
          String(item.id),
          {
            id: String(item.id),
            order: Number(item.order),
            lightness:
              item.lightness === null
                ? null
                : Number(item.lightness)
          }
        );
      }
    });

    return Array.from(unique.values())
      .sort((a, b) => a.order - b.order);
  }

  async loadProductCards() {
    if (!this.mainSectionId) {
      throw new Error(
        'Main collection section not found.'
      );
    }

    const firstHTML =
      await this.fetchSection(
        this.mainSectionId,
        1
      );

    const first =
      this.parseProductSection(firstHTML);

    const allPages = [first];

    if (first.pages > 1) {
      const pages = [];

      for (
        let page = 2;
        page <= first.pages;
        page++
      ) {
        pages.push(page);
      }

      const remaining =
        await this.fetchInBatches(
          pages,
          2,
          async (page) => {
            const html =
              await this.fetchSection(
                this.mainSectionId,
                page
              );

            return this.parseProductSection(
              html
            );
          }
        );

      allPages.push(...remaining);
    }

    const cards = new Map();

    allPages.forEach((page) => {
      page.cards.forEach((card) => {
        const productId =
          card.dataset.productId;

        if (!productId) return;

        /*
          Force all additional product images to remain lazy.
          They will load normally as the customer scrolls.
        */
        card
          .querySelectorAll('img')
          .forEach((image) => {
            image.setAttribute(
              'loading',
              'lazy'
            );

            image.setAttribute(
              'fetchpriority',
              'low'
            );
          });

        if (!cards.has(productId)) {
          cards.set(productId, card);
        }
      });
    });

    return cards;
  }

  async fetchSection(sectionId, page) {
    const url =
      new URL(window.location.href);

    url.hash = '';

    url.searchParams.set(
      'section_id',
      sectionId
    );

    url.searchParams.set(
      'page',
      String(page)
    );

    /*
      Colour ranking always blends against the collection's
      normal Best selling order.
    */
    url.searchParams.set(
      'sort_by',
      'best-selling'
    );

    const response =
      await fetch(
        url.toString(),
        {
          credentials: 'same-origin',
          headers: {
            'X-Requested-With':
              'XMLHttpRequest'
          }
        }
      );

    if (!response.ok) {
      throw new Error(
        `Section request failed: ${response.status}`
      );
    }

    return response.text();
  }

  parseRankingSection(html) {
    /*
      Template content is inert.
      Images/scripts inside fetched markup are not activated.
    */
    const template =
      document.createElement('template');

    template.innerHTML = html;

    const data =
      template.content.querySelector(
        '[data-kf-colour-rank-data]'
      );

    const pagesElement =
      template.content.querySelector(
        '[data-kf-colour-rank-pages]'
      );

    let items = [];

    if (data?.textContent) {
      try {
        items =
          JSON.parse(data.textContent);
      } catch (error) {
        console.error(
          '[KF Colour Shade] Invalid ranking data',
          error
        );
      }
    }

    const pages =
      Number(
        pagesElement?.dataset
          .kfColourRankPages || 1
      );

    return {
      items,
      pages
    };
  }

  parseProductSection(html) {
    const template =
      document.createElement('template');

    template.innerHTML = html;

    const grid =
      template.content.querySelector(
        '[data-testid="product-grid"]'
      );

    if (!grid) {
      return {
        pages: 1,
        cards: []
      };
    }

    const cards =
      Array.from(
        grid.querySelectorAll(
          ':scope > li[data-product-id]'
        )
      );

    return {
      pages:
        Number(
          grid.dataset.lastPage || 1
        ),
      cards
    };
  }

  async fetchInBatches(
    values,
    batchSize,
    callback
  ) {
    const results = [];

    for (
      let i = 0;
      i < values.length;
      i += batchSize
    ) {
      const batch =
        values.slice(
          i,
          i + batchSize
        );

      const batchResults =
        await Promise.all(
          batch.map(callback)
        );

      results.push(...batchResults);
    }

    return results;
  }

  scheduleRanking(value) {
    if (this.rankFrame) {
      cancelAnimationFrame(
        this.rankFrame
      );
    }

    this.rankFrame =
      requestAnimationFrame(() => {
        this.applyRanking(value);
      });
  }

  applyRanking(value) {
    const currentGrid =
      document.querySelector(
        'collection-component results-list[section-id] [data-testid="product-grid"]'
      );

    if (!currentGrid) return;

    this.grid = currentGrid;

    const usable =
      this.metadata.filter(
        (item) =>
          this.cards.has(item.id)
      );

    if (!usable.length) return;

    const bestSelling =
      [...usable].sort(
        (a, b) =>
          a.order - b.order
      );

    let ordered =
      bestSelling;

    if (value !== 0) {
      const valid =
        usable.filter(
          (item) =>
            Number.isFinite(
              item.lightness
            )
        );

      const shadeOrder =
        [...valid].sort(
          (a, b) => {
            /*
              Negative = Light
              Positive = Dark
            */
            if (value < 0) {
              return (
                b.lightness -
                a.lightness
              );
            }

            return (
              a.lightness -
              b.lightness
            );
          }
        );

      const shadeRank =
        new Map();

      shadeOrder.forEach(
        (item, index) => {
          shadeRank.set(
            item.id,
            index
          );
        }
      );

      const strength =
        Math.abs(value) / 100;

      ordered =
        [...usable].sort(
          (a, b) => {
            const targetA =
              shadeRank.has(a.id)
                ? shadeRank.get(a.id)
                : a.order;

            const targetB =
              shadeRank.has(b.id)
                ? shadeRank.get(b.id)
                : b.order;

            const scoreA =
              a.order *
                (1 - strength) +
              targetA *
                strength;

            const scoreB =
              b.order *
                (1 - strength) +
              targetB *
                strength;

            return scoreA - scoreB;
          }
        );
    }

    const fragment =
      document.createDocumentFragment();

    const used =
      new Set();

    ordered.forEach((item) => {
      const card =
        this.cards.get(item.id);

      if (!card) return;

      used.add(item.id);
      fragment.appendChild(card);
    });

    /*
      Preserve any unexpected product without ranking data
      rather than dropping it from the collection.
    */
    this.cards.forEach(
      (card, productId) => {
        if (!used.has(productId)) {
          fragment.appendChild(card);
        }
      }
    );

    /*
      Once custom ranking is active we have the complete
      collection in the DOM, so Horizon must not append
      duplicate infinite-scroll pages.
    */
    this.resultsList =
      document.querySelector(
        'collection-component results-list[section-id]'
      );

    this.resultsList
      ?.querySelectorAll(
        '[ref="viewMoreNext"], [ref="viewMorePrevious"]'
      )
      .forEach(
        (element) =>
          element.remove()
      );

    currentGrid.dataset.lastPage = '1';

    currentGrid.replaceChildren(
      fragment
    );

    this.activated = true;

    this.updateStatus(value);
  }
}

if (
  !customElements.get(
    'kf-colour-refine'
  )
) {
  customElements.define(
    'kf-colour-refine',
    KFColourRefine
  );
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kf-devonstone-fashion-feature"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kf-devonstone-fashion')) {
    class KfDevonstoneFashion extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-fashion-viewport]');
        this.slides = [...this.querySelectorAll('[data-fashion-slide]')];
        if (!this.viewport || this.slides.length < 2) return;

        this.previous = this.querySelector('[data-fashion-previous]');
        this.next = this.querySelector('[data-fashion-next]');
        this.current = this.querySelector('[data-fashion-current]');
        this.index = 0;
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');

        this.onScroll = () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.update());
        };
        this.onPrevious = () => this.goTo(this.index - 1);
        this.onNext = () => this.goTo(this.index + 1);
        this.onKeydown = (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.goTo(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        };
        this.onBlockSelect = (event) => {
          const slide = event.target.closest('[data-fashion-slide]');
          if (slide) this.goTo(this.slides.indexOf(slide));
        };

        this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
        this.viewport.addEventListener('keydown', this.onKeydown);
        this.previous?.addEventListener('click', this.onPrevious);
        this.next?.addEventListener('click', this.onNext);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.resizeObserver = new ResizeObserver(() => this.goTo(this.index, true));
        this.resizeObserver.observe(this.viewport);
        this.update();
      }

      disconnectedCallback() {
        if (!this.viewport || this.slides.length < 2) return;
        this.viewport.removeEventListener('scroll', this.onScroll);
        this.viewport.removeEventListener('keydown', this.onKeydown);
        this.previous?.removeEventListener('click', this.onPrevious);
        this.next?.removeEventListener('click', this.onNext);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.scrollFrame);
      }

      goTo(index, immediate = false) {
        const destination = Math.max(0, Math.min(index, this.slides.length - 1));
        const left = this.slides[destination].offsetLeft - this.slides[0].offsetLeft;
        this.viewport.scrollTo({
          left,
          behavior: immediate || this.reducedMotion.matches ? 'auto' : 'smooth',
        });
        this.index = destination;
        this.updateControls();
      }

      update() {
        const offset = this.slides[0].offsetLeft;
        const position = this.viewport.scrollLeft;
        let closest = 0;
        let distance = Infinity;

        this.slides.forEach((slide, index) => {
          const delta = Math.abs(slide.offsetLeft - offset - position);
          if (delta < distance) {
            closest = index;
            distance = delta;
          }
        });

        this.index = closest;
        this.updateControls();
      }

      updateControls() {
        if (this.current) this.current.textContent = String(this.index + 1);
        if (this.previous) this.previous.disabled = this.index === 0;
        if (this.next) this.next.disabled = this.index === this.slides.length - 1;
      }
    }

    customElements.define('kf-devonstone-fashion', KfDevonstoneFashion);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kf-featured-fabric-swatches"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialiseSwatches = (section) => {
      if (section.dataset.kfSwatchesInitialised === 'true') return;

      const track = section.querySelector('[data-kf-swatch-track]');
      const controls = section.querySelector('[data-kf-slider-controls]');
      const previousButton = section.querySelector('[data-kf-slider-previous]');
      const nextButton = section.querySelector('[data-kf-slider-next]');

      if (!track || !controls || !previousButton || !nextButton) return;

      section.dataset.kfSwatchesInitialised = 'true';

      const isSlider = () => {
        return section.classList.contains(
          'kf-featured-swatches--layout-slider'
        );
      };

      const getGap = () => {
        const trackStyles = window.getComputedStyle(track);

        return (
          parseFloat(
            trackStyles.columnGap || trackStyles.gap
          ) || 0
        );
      };

      const updateGridColumns = () => {
        if (isSlider()) return;

        const items = track.querySelectorAll(
          '.kf-featured-swatches__item'
        );

        if (!items.length) return;

        const sectionStyles = window.getComputedStyle(section);

        const preferredCardWidth =
          parseFloat(
            sectionStyles.getPropertyValue(
              '--kf-swatch-card-width'
            )
          ) || 320;

        const maximumColumns =
          parseInt(
            sectionStyles.getPropertyValue(
              '--kf-swatch-maximum-columns'
            ),
            10
          ) || 4;

        const gap = getGap();
        const availableWidth = track.clientWidth;

        const fittingColumns = Math.max(
          1,
          Math.floor(
            (availableWidth + gap) /
            (preferredCardWidth + gap)
          )
        );

        const currentColumns = Math.max(
          1,
          Math.min(
            maximumColumns,
            items.length,
            fittingColumns
          )
        );

        track.style.setProperty(
          '--kf-swatch-current-columns',
          currentColumns
        );
      };

      const getScrollAmount = () => {
        const firstCard = track.querySelector(
          '.kf-featured-swatches__item'
        );

        return firstCard
          ? firstCard.getBoundingClientRect().width + getGap()
          : track.clientWidth;
      };

      const updateSliderControls = () => {
        if (!isSlider()) {
          controls.hidden = true;
          return;
        }

        const maximumScroll = Math.max(
          0,
          track.scrollWidth - track.clientWidth
        );

        const hasOverflow = maximumScroll > 2;

        controls.hidden = !hasOverflow;
        previousButton.disabled = track.scrollLeft <= 2;
        nextButton.disabled =
          track.scrollLeft >= maximumScroll - 2;
      };

      const updateLayout = () => {
        updateGridColumns();
        updateSliderControls();
      };

      previousButton.addEventListener('click', () => {
        track.scrollBy({
          left: -getScrollAmount(),
          behavior: 'smooth'
        });
      });

      nextButton.addEventListener('click', () => {
        track.scrollBy({
          left: getScrollAmount(),
          behavior: 'smooth'
        });
      });

      track.addEventListener('scroll', updateSliderControls, {
        passive: true
      });

      if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(updateLayout);
        resizeObserver.observe(track);
      } else {
        window.addEventListener('resize', updateLayout);
      }

      updateLayout();
    };

    const initialiseAllSwatches = (root = document) => {
      if (root.matches?.('[data-kf-featured-swatches]')) {
        initialiseSwatches(root);
      }

      root
        .querySelectorAll('[data-kf-featured-swatches]')
        .forEach(initialiseSwatches);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initialiseAllSwatches();
      });
    } else {
      initialiseAllSwatches();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initialiseAllSwatches(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kf-recommendations"] && !Shopify.designMode) return;
  try {
    
  class KfProductRecommendationsCarousel extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;

      const track = this.querySelector('[data-kf-recommendations-track]');
      const controls = this.querySelector('[data-kf-recommendations-controls]');
      const previousButton = this.querySelector('[data-kf-recommendations-previous]');
      const nextButton = this.querySelector('[data-kf-recommendations-next]');

      if (!track || !controls || !previousButton || !nextButton) return;

      this.abortController = new AbortController();
      const { signal } = this.abortController;

      const getGap = () => {
        const trackStyles = window.getComputedStyle(track);
        return parseFloat(trackStyles.columnGap || trackStyles.gap) || 0;
      };

      const getScrollAmount = () => {
        const firstItem = track.querySelector('.kf-product-recommendations__item');
        return firstItem ? firstItem.getBoundingClientRect().width + getGap() : track.clientWidth;
      };

      const updateControls = () => {
        const maximumScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        const hasOverflow = maximumScroll > 2;

        controls.hidden = !hasOverflow;
        previousButton.disabled = track.scrollLeft <= 2;
        nextButton.disabled = track.scrollLeft >= maximumScroll - 2;
      };

      previousButton.addEventListener(
        'click',
        () => track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' }),
        { signal }
      );

      nextButton.addEventListener(
        'click',
        () => track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' }),
        { signal }
      );

      track.addEventListener('scroll', updateControls, { passive: true, signal });

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(updateControls);
        this.resizeObserver.observe(track);
      } else {
        window.addEventListener('resize', updateControls, { signal });
      }

      requestAnimationFrame(updateControls);
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
      this.abortController = null;
      this.resizeObserver = null;
    }
  }

  if (!customElements.get('kf-product-recommendations-carousel')) {
    customElements.define('kf-product-recommendations-carousel', KfProductRecommendationsCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
